import { createSlice } from "@reduxjs/toolkit";

export const positionsSlice = createSlice({
  name: "positions",
  initialState: { positions: [], status: "idle", error: null },
  reducers: {
    setPositions: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.positions = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setPositionsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearPositions: (state) => {
      state.positions = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setPositions, setPositionsStatus, clearPositions } =
  positionsSlice.actions;

export default positionsSlice.reducer;
